import React, { Component } from 'react';
import { planName } from '../../configs/plan';

export const massageUrl = (value) => {
    const urls = value
      .replace(/\r\n/g, '\n')
      .split('\n');

    if (urls.length === 0) {
        return [];
    }

    return urls.filter(url => url.length !== 0);
};

export const getDuplicateUrls = (urls) => {
    return urls
            .filter((element, index, url) => url.indexOf(element) !== index)
            .filter((element, index, url) => url.indexOf(element) === index)
}

export const duplicateUrls = (urls) => {
    return urls.length !== new Set(urls).size;
};

export const validateUrlInput = (urls) => {
    const duplicatedUrls = getDuplicateUrls(urls);
    if (duplicatedUrls.length > 0) {
        return 'Please remove the duplicated slug:\n' + duplicatedUrls.join('\n');
    }

    for(let index = 0; index<urls.length; index++){
        if (urls[index].indexOf(' ') >= 0) {
            return 'Please remove spaces!';
        }
        if (containsSpecialChar(urls[index])){
            return 'Please use characters, numbers, dot (.), dash (-) and underscore (_) only to make your URLs user friendly.';
        }
    }

    return false;
}

export const required = value => value ? undefined : 'Required';

export const renderField = ({ input, label, type, className, placeholder, meta: { touched, error, warning } }) => (
    <div>
        <label>{label}</label>
        <div>
            <input {...input} type={type} className={className} placeholder={placeholder}/>
            {touched && ((error && <span className="error">{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

export const renderTextAreaField = ({ input, label, type, className, placeholder, rows, meta: { touched, error, warning } }) => (
    <div>
        <label>{label}</label>
        <div>
            <textarea {...input} type={type} className={className} placeholder={placeholder} rows={rows}/>
            {touched && ((error && <span className="error" style={{whiteSpace: 'pre-line'}}>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

// Only support translation on PDA Gold.
export const __ = (text, domain) => {
	if ( ! wp.i18n || typeof wp.i18n.__ !== 'function' ) {
		return text;
	} else {
		if (planName === 'gold') {
			return wp.i18n.__(text, 'prevent-direct-access-gold');
		}
	}
	return text;
}

export const containsSpecialChar = (str) => {
    return /[~`!#$%\^@&*+=\(\)\[\]\\';,/{}|\\":<>\?]/g.test(str);
}

export const mustLargerThan0 = (n) => {
    return Number.parseInt(n) > 0;
}

export const validate = values => {
    const errors = {};
    const requiredFields = [ 'url' ];
    requiredFields.forEach(field => {
        if (!values[ field ]) {
            errors[ field ] = 'Required'
        } else {
            const urls = massageUrl(values[ field ]);
            const message = validateUrlInput(urls);
            if (message) {
                errors[ field ] = message;
            }
        }
    });

    const numberFields = [ 'limit_downloads' ];
    numberFields.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    const validateExpired = [ 'expired_days' ];
    validateExpired.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    const validateLimitDownloadPRU = [ 'private_link_user_limit_downloads' ];
    validateLimitDownloadPRU.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    const validateExpiredPRU = [ 'private_link_user_expired_days' ];
    validateExpiredPRU.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }
    return errors;
}
